import React from 'react';
import styles from './DancingHeadline.module.css';

interface Props {
  headline: string;
}

export function DancingHeadline(props: Props): React.ReactElement {
  return (
    <span className={styles.container}>
      {props.headline.replace(/[\n\r]+/g, '\n')}
    </span>
  );
}
